
import { useNavigate } from "react-router-dom";
import { useRoutineSubscriptions } from "@/components/routines/sections/hooks/useRoutineSubscriptions";
import { RoutineShimmer } from "@/components/routines/RoutineShimmer";
import { useWorkoutPlanData } from "../hooks/useWorkoutPlanData";
import { useWorkoutPlanRealtime } from "../hooks/useWorkoutPlanRealtime";
import { WorkoutPlanHeader } from "./WorkoutPlanHeader";
import { WorkoutPlanContent } from "./WorkoutPlanContent";

interface WorkoutPlanContainerProps {
  planId?: string;
  initialPlan?: any;
  hideBackButton?: boolean;
}

export const WorkoutPlanContainer = ({
  planId: propPlanId,
  initialPlan,
  hideBackButton
}: WorkoutPlanContainerProps) => {
  const navigate = useNavigate();
  
  const {
    planId,
    profile,
    workoutPlan,
    personalRoutines,
    routinesToShow,
    isLoading,
    canEdit,
    updateCounter,
    updateExerciseField,
    handleStructuralRefetch,
    handleMinimalRefetch,
    handleAddRoutine,
    handleRemoveRoutine
  } = useWorkoutPlanData({ planId: propPlanId, initialPlan });

  useRoutineSubscriptions(profile, personalRoutines, () => handleStructuralRefetch());
  
  useWorkoutPlanRealtime({
    planId,
    planRoutines: routinesToShow,
    updateExerciseField,
    handleStructuralRefetch,
    handleMinimalRefetch
  });
  
  if (isLoading) {
    return (
      <div className="space-y-4 sm:space-y-6">
        <RoutineShimmer />
      </div>
    );
  }
  
  if (!workoutPlan) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center text-primary/60">Plan no encontrado</div>
      </div>
    );
  }
  
  // DEBUG: Logs detallados para identificar el problema
  console.log("🔍 DEBUG WorkoutPlanContainer - Plan Details:", {
    planId,
    isPlanPersonal: workoutPlan.is_personal,
    canEdit,
    planCreatedBy: workoutPlan.created_by,
    profileId: profile?.id,
    totalPlanRoutines: routinesToShow.length,
    updateCounter,
    planName: workoutPlan.name
  });
  
  return (
    <div className="space-y-4 sm:space-y-6">
      <WorkoutPlanHeader 
        onBack={() => navigate("/rutina")} 
        hideBackButton={hideBackButton} 
        canEdit={canEdit} 
        planId={planId!} 
        onAddRoutine={handleAddRoutine}
        mode={(workoutPlan.mode as "days" | "sequential") || "days"}
        routines={routinesToShow}
      />

      <WorkoutPlanContent 
        routines={routinesToShow} 
        onRoutinesChange={handleMinimalRefetch}
        onRemoveRoutine={handleRemoveRoutine} 
        showRemoveButton={canEdit} 
        planId={planId!} 
        isPersonalPlan={workoutPlan.is_personal} 
        canEdit={canEdit}
        updateCounter={updateCounter}
        mode={(workoutPlan.mode as "days" | "sequential") || "days"}
        onSequentialChange={handleStructuralRefetch}
      />
    </div>
  );
};
